import type {
  NewsletterPayload,
  NewsletterRequestDto,
  NewsletterSuccessResponse,
} from './Newsletter.types';

export const mapNewsletterPayloadToRequestDto = (
  payload: NewsletterPayload,
): NewsletterRequestDto => ({
  email: payload.newsletterEmail.trim().toLowerCase(),
});

export const mapNewsletterSuccessResponse = (
  response: NewsletterSuccessResponse,
): NewsletterSuccessResponse => {
  return {
    status: response.status,
    code: response.code,
    message: response.message,
    data: response.data,
  };
};
